import NotchedOutlinedBox from './NotchedOutlinedBox';

export default NotchedOutlinedBox;
